import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import {
  BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER,
  BUILDING_FORM_FIELD_NAME_UPDATE_MANAGER_FOR_ALL_BUILDINGS_IN_GROUP,
} from '../../../BuildingForm.constants'

export function useResetUpdateManagerCheckbox() {
  const { setFieldValue, values } = useFormikContext()

  useEffect(() => {
    if (values[BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER]?.length === 0) {
      setFieldValue(
        BUILDING_FORM_FIELD_NAME_UPDATE_MANAGER_FOR_ALL_BUILDINGS_IN_GROUP,
        false
      )
    }
  }, [values[BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER]])
}
